/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Subnet configuration for network interface creation
*/
export class SubnetConfig {
  /**
  * Whether to use an existing subnet or create a new one
  */
  'mode': SubnetConfigModeEnum;
  /**
  * Subnet name. Required when mode=existing. Optional when mode=create (defaults to eon-default-subnet-<region>). 
  */
  'name'?: string;
  /**
  * Address prefix in CIDR notation. Only used when mode=create. Defaults to 10.0.0.0/24 if not specified. 
  */
  'addressPrefix'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "mode",
      "baseName": "mode",
      "type": "SubnetConfigModeEnum",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "addressPrefix",
      "baseName": "addressPrefix",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SubnetConfig.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum SubnetConfigModeEnum {
  Existing = 'existing',
  Create = 'create'
}

